import api from "!../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.104.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.104.1/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../../../node_modules/.pnpm/vue-loader@16.8.3_@vue+comp_5cff2737dde116e8fc1156af408c1302/node_modules/vue-loader/dist/stylePostLoader.js!../../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.6_webpack@5.104.1/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!../../../../node_modules/.pnpm/vue-loader@16.8.3_@vue+comp_5cff2737dde116e8fc1156af408c1302/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AddUpdateTRCCoupleContent.vue?vue&type=style&index=0&id=15c70886&lang=css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};